import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function GuaranteeSection() {
  return <section style={{
    background: '#F2EDE4',
    padding: '80px 24px'
  }} data-id="element-16">
      <div style={{
      maxWidth: '720px',
      margin: '0 auto'
    }} data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} style={{
        background: '#fff',
        border: '2px solid #E8DDD0',
        borderRadius: '24px',
        padding: '48px 40px',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(28,28,30,0.08)',
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-18">
          <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #1B5E3B, #C9973A, #1B5E3B)'
        }} data-id="element-19" />

          <div style={{
          width: '72px',
          height: '72px',
          background: '#EAF4EE',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }} data-id="element-20">
            <ShieldCheck size={36} style={{
            color: '#1B5E3B'
          }} data-id="element-21" />
          </div>

          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(22px, 3vw, 34px)',
          fontWeight: 700,
          color: '#1C1C1E',
          marginBottom: '18px',
          lineHeight: 1.3
        }} data-id="element-22">
            Garantia de Devolucion de 7 Dias
          </h2>

          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '17px',
          color: '#4A4A4A',
          lineHeight: 1.8,
          marginBottom: '28px',
          maxWidth: '520px',
          margin: '0 auto 28px'
        }} data-id="element-23">
            Si en 7 dias no sientes que este es el camino a tu libertad,{' '}
            <strong style={{
            color: '#1C1C1E'
          }} data-id="element-24">
              te devolvemos cada centavo.
            </strong>{' '}
            Sin preguntas. Sin formularios complicados. Sin demoras.
          </p>

          <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          background: '#EAF4EE',
          borderRadius: '100px',
          padding: '12px 24px',
          border: '1px solid rgba(27,94,59,0.2)'
        }} data-id="element-25">
            <span style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '16px',
            fontWeight: 700,
            color: '#1B5E3B',
            fontStyle: 'italic'
          }} data-id="element-26">
              Madres apoyando madres.
            </span>
          </div>

          <a href="#precio" style={{
          textDecoration: 'none',
          display: 'inline-block',
          marginTop: '24px'
        }} data-id="element-27">
            <button style={{
            background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
            color: '#fff',
            fontFamily: "'Lato', sans-serif",
            fontWeight: 900,
            fontSize: '15px',
            letterSpacing: '0.5px',
            padding: '16px 32px',
            borderRadius: '12px',
            border: '2px solid #C9973A',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} data-id="element-28">
              QUIERO EMPEZAR HOY — $6.36
              <ArrowRight size={16} data-id="element-29" />
            </button>
          </a>

          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '12px',
          color: '#8A8A8A',
          marginTop: '12px',
          marginBottom: 0
        }} data-id="element-30">
            Garantia valida por 7 dias calendario desde la fecha de compra.
            Aplica devolucion completa del precio pagado.
          </p>
        </motion.div>
      </div>
    </section>;
}